// @ts-strict-ignore
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { PostSearchInput } from 'components/Post/PostSearchInput';
import { NoAmp } from 'containers/NoAmp';
import {
  resetSearchFilters,
  setSearchQuery,
} from 'store/main/ducks/postSearch';
import { filterObject, isEmpty, mapObject, values } from 'utils/functional';
import { truncateToUTF8Bytes } from 'utils/string';

type InitialProps = {
  isStatic?: boolean;
  pill?: string;
  homePageUrl: string;
  searchPlaceholderText?: string;
};

type OwnProps = InitialProps & RouteComponentProps;

type Props = OwnProps & {
  query: string;
  resetSearchFilters: typeof resetSearchFilters;
  setSearchQuery: typeof setSearchQuery;
};
type State = {
  query: string;
  prevProps: {
    query: string;
  };
};

const toQueryParamKey = (k: string) => {
  const mapping = {
    query: 'pq',
  };
  return mapping[k] || k;
};

const makeQueryString = (props: { type?: string; query?: string }) => {
  const search = values(
    mapObject(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type?: string; query?: string;... Remove this comment to see the full error message
      filterObject(props, (k) => !isEmpty(k)),
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      (k, v) => [k, `${toQueryParamKey(k)}=${v}`]
    )
  ).join('&');
  return isEmpty(search) ? '' : `?${search}`;
};

class PostSearchInputContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    query: this.props.query || '',

    prevProps: {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      query: this.props.query,
    },
  };

  onSearch = (props: { homePageUrl: string; query?: string }) => {
    const { homePageUrl, ...queryProps } = props;
    const queryString = makeQueryString(queryProps);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.history.push(`/${homePageUrl}${queryString}`);
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const updatedState = ['query'].reduce((acc, prop) => {
      if (props[prop] !== state.prevProps[prop]) {
        // eslint-disable-next-line no-param-reassign
        acc[prop] = props[prop];
      }

      return acc;
    }, {});

    if (Object.keys(updatedState).length > 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'prevProps' does not exist on type '{}'.
      updatedState.prevProps = {
        query: props.query,
      };
      return updatedState;
    }

    return null;
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setQuery = (query: string, callback?: (...args: Array<any>) => any) => {
    // Algolia has a max query length of 512 bytes
    this.setState(
      {
        query: truncateToUTF8Bytes(query, 512),
      },
      callback
    );
  };

  search = () => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.resetSearchFilters();

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.query !== this.state.query) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.setSearchQuery(this.state.query, true);
    }

    const { query } = this.state;
    this.onSearch({
      query,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      homePageUrl: this.props.homePageUrl,
    });
  };

  render() {
    const { query } = this.state;
    const { setQuery, search } = this;
    return (
      <NoAmp>
        <PostSearchInput
          data-qa-id="post-search-input"
          query={query}
          search={search}
          placeholder={
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            this.props.searchPlaceholderText // TODO: Fix this the next time the file is edited.
              ? // eslint-disable-next-line react/destructuring-assignment
                this.props.searchPlaceholderText
              : getText('Search articles')
          }
          setQuery={setQuery}
          clearQuery={() => {
            setQuery('', search);
          }}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          isStatic={this.props.isStatic}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          pill={this.props.pill}
        />
      </NoAmp>
    );
  }
}

const mapStateToProps = ({ postSearch: { query } }) => ({
  query,
});

// eslint-disable-next-line import/no-default-export
export default withRouter(
  connect(mapStateToProps, {
    resetSearchFilters,
    setSearchQuery,
  })(PostSearchInputContainer)
);
